export const Logo_URL =
  "https://help.nflxext.com/helpcenter/OneTrust/oneTrust_production_2026-01-09/consent/87b6a5c0-0104-4e96-a291-092c11350111/019ae4b5-d8fb-7693-90ba-7a61d24a8837/logos/dd6b162f-1a32-456a-9cfe-897231c7763c/4345ea78-053c-46d2-b11e-09adaef973dc/Netflix_Logo_PMS.png";
export const user_AVATHAR =
  "https://i.pinimg.com/736x/91/86/1b/91861b749841221d52122f0c2933d8a6.jpg";

export const API_OPTIONS = {
  method: "GET",
  headers: {
    accept: "application/json",
    Authorization:
      "Bearer eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiI4YmQxMjdmYjJmYWEyNDUzN2E3OGIxZjcyM2RjMTkzMiIsIm5iZiI6MTc2OTg1NTA2NC4xMDYsInN1YiI6IjY5N2RkODU4NmM3MGE5YmNkZDcxOWNhMCIsInNjb3BlcyI6WyJhcGlfcmVhZCJdLCJ2ZXJzaW9uIjoxfQ.NR8C7M27fd9W4tbMfe6GnhcO4IFig8BcAF96_bK8pg4",
  },
};

export const IMG_CDN_URL = "https://image.tmdb.org/t/p/w500/";

